<svg width="24" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="3" y="2.5" width="19" height="19" rx="1" fill="#000"/>
  <rect x="9" y="3.5" width="5" height="5" rx="0.653846" transform="rotate(90 9 3.5)" fill="#fff"/>
  <rect x="15" y="3.5" width="5" height="5" rx="0.653846" transform="rotate(90 15 3.5)" fill="#fff"/>
  <rect x="21" y="3.5" width="5" height="5" rx="0.653846" transform="rotate(90 21 3.5)" fill="#fff"/>
  <rect x="9" y="9.5" width="5" height="5" rx="0.653846" transform="rotate(90 9 9.5)" fill="#fff"/>
  <rect x="15" y="9.5" width="5" height="5" rx="0.653846" transform="rotate(90 15 9.5)" fill="#fff"/>
  <rect x="21" y="9.5" width="5" height="5" rx="0.653846" transform="rotate(90 21 9.5)" fill="#fff"/>
  <rect x="9" y="15.5" width="5" height="5" rx="0.653846" transform="rotate(90 9 15.5)" fill="#fff"/>
  <rect x="15" y="15.5" width="5" height="5" rx="0.653846" transform="rotate(90 15 15.5)" fill="#fff"/>
  <rect x="21" y="15.5" width="5" height="5" rx="0.653846" transform="rotate(90 21 15.5)" fill="#fff"/>
</svg>
